export default __webpack_public_path__ + "static/media/img6.297c0419.png";